import type { SiteContactPublic } from '../types/siteContact.js';

type MainPhoneProfile = Pick<SiteContactPublic, 'mainPhoneDisplay' | 'mainPhoneVisible'>;

/** Public phone string only when visible and non-empty; otherwise null (no tel: / no placeholder). */
export function resolvePublicMainPhone(profile: MainPhoneProfile | null | undefined): string | null {
  if (!profile?.mainPhoneVisible) {
    return null;
  }
  const phone = profile.mainPhoneDisplay?.trim();
  return phone || null;
}

/** Digits-only tel: href body, or null when phone must not be shown. */
export function resolvePublicMainPhoneTel(profile: MainPhoneProfile | null | undefined): string | null {
  const phone = resolvePublicMainPhone(profile);
  if (!phone) {
    return null;
  }
  const tel = phone.replace(/[^+\d]/g, '');
  return tel || null;
}
